<!--
 * @Description: 
 * @Author: dingxianzhi
 * @Email: dingxz@moofen.cn
 * @Date: 2022-01-21 15:03:23
 * @LastEditTime: 2023-02-07 09:26:24
-->
<template>
  <div id="app">
    <div class="group_heads" v-show="!down">
      <router-link class="backIcon" to="/exam"><i class="el-icon-arrow-left"></i>返回列表</router-link>
      <span>{{ title }}</span>
    </div>
    <div class="exam_heads" v-show="down == 2">
      <span>答题卡列表</span>
      <div class="right-panel">
        <el-dropdown size="medium" @command="handleCommand">
          <span class="avatar-dropdown flex-b-c">
            <el-avatar src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif"></el-avatar>
            <span class="user-name">{{ info }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" size="medium">
            <el-dropdown-item class="dropdown-item" icon="el-icon-switch-button" command="out">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
       this.info=localStorage.getItem('user');
      },
      immediate: true
    },
  },
  computed: {
    title() {
      return this.$route.name == 'preview' ? '答题卡预览' : '制作答题卡'
    },

    down() {
      return this.$route.query.down || this.$route.name == 'preview' ? 1 : this.$route.name == 'Exam' ? 2 : this.$route.name != '/' && this.$route.name != 'Home' ? 1 : 0
    }
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "out":
          this.$confirm("您确定要继续退出吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              location.reload();
            })
            .catch(() => { });
          break;
      }
    },
  }
}
</script>


<style lang="less">
@import '~@/assets/css/variables.less';

#app {
  height: 100%;
}

.group_heads {
  height: 50px;
  line-height: 50px;
  width: 100%;
  background-color: @white;
  position: relative;
  z-index: 10;
  text-align: center;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  top: 0;
}

.exam_heads {
  height: 50px;
  line-height: 50px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  position: sticky;
  z-index: 10;
  text-align: center;
  color: #333;
  font-size: 16px;
  top: 0;
  position: relative;

  .right-panel {
    position: absolute;
    right: 15px;
    top: 0;

    .user-name {
      padding-left: 4px;
    }
  }
}

.backIcon {
  position: absolute;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  left: 15px;
  text-decoration: none;

  i {
    font-size: 20px;
    margin-right: 4px;
    vertical-align: text-top;
  }
}

.miniScoreHeight {
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid #000;

  .item {
    height: 24px;
    flex: 1;
    text-align: center;
    box-sizing: border-box;
    // border-top: 1px solid #000;
    border-left: 1px solid #000;
    font-size: 12px;
    line-height: 24px;

    &:first-child {
      // border-right: 1px solid #000;
    }

    &:last-child {
      border-left-width: 0
    }
  }
}

.mce-content-body {
  border: none !important;

  &.mce-edit-focus {
    outline: none;
    border: none !important;
    box-shadow: none;
  }
}

.question-title {
  .el-input--medium {
    font-size: 16px !important;

    .el-input__inner,
    .el-textarea__inner {
      font-size: 16px;
      color: #000;
      padding-left: 3px !important;
      border-radius: 0;
      border-style: solid !important;
      text-align: left;
      min-height: 30px !important;
      height: 30px;
    }
  }

  div {
    line-height: 28px;
  }

  /*   .el-textarea.el-input--medium textarea.el-textarea__inner{
    min-height: 30px !important;
    height: 30px !important;
    color: #000;
  } */
}
</style>
